import { Fab, makeStyles, useTheme, Zoom } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
    fab: {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
        zIndex: 100000,
    }
});

const FloatingAction = ({ show, color, icon, disabled = false, onClick }) => {
    const styles = useStyles();
    const theme = useTheme();

    const transitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };

    return (
        <Zoom
            in={show}
            timeout={transitionDuration}
            style={{
                transitionDelay: `${show ? transitionDuration.exit : 0}ms`,
            }}
            unmountOnExit
        >
            <Fab
                color={color ? color : "primary"}
                onClick={onClick}
                className={styles.fab}
                disabled={disabled}
            >
                {icon}
            </Fab>
        </Zoom>
    );
};

export default FloatingAction;